import http from './index'

export default {
  /*
   * 获取菜单列表
   * */
  list (params) {
    return http.get('/front/menu/getMenuTree', params)
  },
  // 查询工具栏
  toolBarList (params) {
    return http.get('/front/toolbar/toolbarTree', params)
  },
  /*
   * 添加菜单
   * */
  add (params) {
    return http.post('/front/menu/save', params)
  },
  // 添加工具栏导航
  addTool (params) {
    return http.post('/front/toolbar/save', params)
  },
  /*
   * 删除菜单
   * */
  remove (params) {
    return http.post('/front/menu/delete', params)
  },
  // 删除工具栏导航
  removeTool (params) {
    return http.post('/front/toolbar/delete', params)
  },
  /*
   * 编辑菜单
   * */
  edit (params) {
    delete params.sortIndex
    return http.post('/front/menu/update', params)
  },
  // 编辑工具栏
  editTool (params) {
    return http.post('/front/toolbar/update', params)
  },
  /*
   * 迁移菜单
   * */
  move (params) {
    return http.post('/front/menu/move', params)
  },
  // 迁移导航工具栏
  moveTool (params) {
    return http.post('/front/toolbar/move', params)
  },
  /*
   * 移动菜单
   * */
  reOrder (params) {
    return http.post('/front/menu/sort', params)
  },
  // 移动导航工具栏
  reOrderTool (params) {
    return http.post('/front/toolbar/sort', params)
  },
  /** 获取首页应用菜单
   * */
  getHomeMenu () {
    return http.get('/front/menu/getHomeMenu')
  },
  /*
   * 获取系统配置菜单
   * */
  getConfigMenu () {
    return http.get('/front/menu/getConfigMenu')
  },
  // 获取个人中心菜单
  getPersonalMenu () {
    return http.get('/front/menu/getPersonalMenu')
  },
  // 全量同步菜单
  listSync () {
    return http.get('/front/menu/synchronization')
  }
}
